import React from "react";

export default function BooksLanding() {
  const availableBooks = [
    {
      title: "Book 1: Kemet",
      subtitle: "How the Light Was Born",
      description:
        "A gentle retelling of an ancient Egyptian creation story for children — warm, clear, beautiful, and rooted in wonder.",
      image: "/images/books/kemet-cover.png.png",
      buy: "https://a.co/d/1BGMIZa",
      gift: "https://givebutter.com/fDk01G",
      details: [
        "24 pages • full color",
        "Early-reader friendly",
        "Glossary + pronunciation guide",
      ],
    },
    {
      title: "Book 2: Sumerian",
      subtitle: "Creation of the Sky & Sea",
      description:
        "A poetic, child-friendly retelling of the Sumerian creation story with vivid imagery and simple, memorable language.",
      image: "/images/books/one-light-cover.png",
      buy: "https://a.co/d/7Mq53U2",
      gift: "https://givebutter.com/fDk01G",
      details: [
        "24 pages • full color",
        "Educational back matter",
        "Ideal for ages 5–10",
      ],
    },
  ];

  const comingSoon = [
    { t: "Ifá", s: "How the Earth Found Its Balance" },
    { t: "Akan", s: "The Golden Spider’s Web" },
  ];

  return (
    <main className="min-h-screen bg-[#f6f0e6] text-[#191512]">
      {/* NAV */}
      <header className="sticky top-0 z-50 border-b border-black/5 bg-[#f6f0e6]/85 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
          <a href="/" className="leading-tight">
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#8d7761]">
              One Unity Rising
            </p>
            <p className="text-lg font-semibold tracking-tight">Books</p>
          </a>

          <nav className="hidden items-center gap-6 text-sm text-[#6a5a4c] sm:flex">
            <a href="/" className="transition hover:text-black">
              Blk Block
            </a>
           
            <span className="font-semibold text-[#191512]">Books</span>
          </nav>
        </div>
      </header>

      {/* HERO */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 -z-20 bg-[linear-gradient(180deg,#ead8bb_0%,#f6f0e6_40%,#f6f0e6_100%)]" />
        <div className="absolute left-0 top-0 -z-10 h-[420px] w-[420px] rounded-full bg-[#d7a95b]/20 blur-3xl" />
        <div className="absolute bottom-0 right-0 -z-10 h-[380px] w-[380px] rounded-full bg-[#a96c38]/15 blur-3xl" />

        <div className="mx-auto grid max-w-7xl gap-14 px-6 py-16 md:grid-cols-[1.1fr_0.9fr] md:py-24">
          {/* Left */}
          <div className="self-center">
            <p className="text-[11px] font-semibold uppercase tracking-[0.32em] text-[#9c7b51]">
              One Unity Rising • Children’s Books
            </p>

            <h1 className="mt-4 max-w-3xl text-5xl font-semibold leading-[0.96] tracking-tight md:text-7xl">
              One Light, <br />
              Many Names
            </h1>

            <p className="mt-6 max-w-xl text-lg leading-8 text-[#5f5145] md:text-xl">
              A children’s series bringing ancient creation stories to life in a
              way that feels beautiful, simple, rooted, and empowering.
            </p>

            <div className="mt-7 flex flex-wrap gap-2">
              {["Ages 4–10", "Early Readers", "Cultural Roots"].map((b) => (
                <span
                  key={b}
                  className="rounded-full border border-[#d6b98e] bg-white/70 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-[#87653f]"
                >
                  {b}
                </span>
              ))}
            </div>

            <div className="mt-9 flex flex-wrap gap-3">
              <a
                href="https://a.co/d/1BGMIZa"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center rounded-full bg-[#181310] px-6 py-3.5 text-sm font-medium text-white transition hover:bg-black"
              >
                Buy Book 1: Kemet
              </a>
              <a
                href="/"
                className="inline-flex items-center justify-center rounded-full border border-black/10 bg-white px-6 py-3.5 text-sm font-medium text-[#191512] transition hover:bg-[#f2eadf]"
              >
                Return to Blk Block
              </a>
            </div>

            <div className="mt-7 flex flex-wrap items-center gap-4 text-sm text-[#77685a]">
              <div className="flex items-center gap-2">
                <span aria-hidden>★★★★★</span>
                <span>Early reader approved</span>
              </div>
              <span className="hidden sm:inline">•</span>
              <span>Full color • gentle layout</span>
            </div>
          </div>

          {/* Right */}
          <div className="relative flex items-center justify-center">
            <div className="relative w-full max-w-md">
              <div className="absolute inset-x-10 bottom-0 h-16 rounded-full bg-[#c89c57]/35 blur-3xl" />
              <div className="relative rounded-[34px] border border-black/6 bg-[#fbf7f0] p-5 shadow-[0_25px_70px_rgba(58,34,12,0.14)]">
                <img
                  src="/images/books/kemet-cover.png.png"
                  alt="Book 1: Kemet — How the Light Was Born"
                  className="w-full rounded-[24px] object-cover"
                />
              </div>

              <div className="absolute -right-3 top-6 rounded-full border border-[#e0bf79] bg-[#f2c35d] px-4 py-1.5 text-xs font-bold uppercase tracking-[0.14em] text-[#3a2710] shadow-sm">
                New Release
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* INTRO STRIP */}
      <section className="border-y border-black/6 bg-[#1b1512] text-white">
        <div className="mx-auto max-w-7xl px-6 py-12">
          <div className="grid gap-6 md:grid-cols-[0.7fr_1.3fr] md:items-start">
            <div>
              <p className="text-[11px] uppercase tracking-[0.3em] text-[#d6b98d]">
                Why This Series
              </p>
              <h2 className="mt-3 text-3xl font-semibold tracking-tight md:text-4xl">
                Stories children can feel.
              </h2>
            </div>
            <p className="max-w-3xl text-lg leading-8 text-white/76">
              These books are designed to make ancient stories feel accessible,
              soft, memorable, and alive — giving children beauty, language,
              wonder, and cultural grounding without overwhelm.
            </p>
          </div>
        </div>
      </section>

      {/* AVAILABLE NOW */}
      <section className="py-20">
        <div className="mx-auto max-w-7xl px-6">
          <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <p className="text-[11px] uppercase tracking-[0.28em] text-[#9b7b53]">
                Available Now
              </p>
              <h2 className="mt-2 text-4xl font-semibold tracking-tight md:text-5xl">
                Begin with the first stories.
              </h2>
            </div>
            <p className="max-w-xl text-[16px] leading-7 text-[#68594b]">
              Two books are currently available, with more titles growing into a
              larger cultural children’s library.
            </p>
          </div>

          <div className="mt-12 space-y-10">
            {availableBooks.map((book, i) => (
              <article
                key={book.title}
                className="overflow-hidden rounded-[34px] border border-black/7 bg-white shadow-[0_16px_40px_rgba(0,0,0,0.05)]"
              >
                <div
                  className={`grid items-stretch gap-0 lg:grid-cols-2 ${
                    i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
                  }`}
                >
                  <div className="bg-[linear-gradient(180deg,#f3e4cb_0%,#f9f4eb_100%)] p-8 md:p-10">
                    <div className="mx-auto max-w-sm">
                      <div className="rounded-[26px] border border-black/6 bg-white p-4 shadow-[0_18px_40px_rgba(50,30,12,0.08)]">
                        <img
                          src={book.image}
                          alt={`${book.title} — ${book.subtitle}`}
                          className="w-full rounded-[18px] object-contain"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center p-8 md:p-10 lg:p-12">
                    <div className="max-w-xl">
                      <p className="text-[11px] uppercase tracking-[0.28em] text-[#a07f57]">
                        Featured Title
                      </p>
                      <h3 className="mt-3 text-3xl font-semibold leading-tight tracking-tight md:text-4xl">
                        {book.title}
                      </h3>
                      <p className="mt-2 text-lg text-[#8b6742]">
                        {book.subtitle}
                      </p>
                      <p className="mt-5 text-[16px] leading-8 text-[#625447]">
                        {book.description}
                      </p>

                      <ul className="mt-6 space-y-3 text-[15px] text-[#4f443a]">
                        {book.details.map((detail) => (
                          <li key={detail} className="flex items-start gap-3">
                            <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#c88d42]" />
                            <span>{detail}</span>
                          </li>
                        ))}
                      </ul>

                      <div className="mt-8 flex flex-wrap gap-3">
                        <a
                          href={book.buy}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="rounded-full bg-[#181310] px-6 py-3.5 text-sm font-medium text-white transition hover:bg-black"
                        >
                          Buy on Amazon
                        </a>
                        <a
                          href={book.gift}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="rounded-full border border-black/10 bg-[#faf6ef] px-6 py-3.5 text-sm font-medium text-[#191512] transition hover:bg-[#f4ede2]"
                        >
                          Gift a Classroom
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* COMING SOON */}
      <section className="bg-[#ece2d4] py-20">
        <div className="mx-auto max-w-7xl px-6">
          <div className="max-w-2xl">
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#9b7b53]">
              Coming Soon
            </p>
            <h2 className="mt-2 text-4xl font-semibold tracking-tight md:text-5xl">
              The library is growing.
            </h2>
            <p className="mt-5 text-[16px] leading-8 text-[#66584c]">
              Future titles expand the vision into more ancestral stories told
              with clarity, tenderness, and beauty for children.
            </p>
          </div>

          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {comingSoon.map((b) => (
              <div
                key={b.t}
                className="overflow-hidden rounded-[30px] border border-black/7 bg-white shadow-[0_12px_30px_rgba(0,0,0,0.04)]"
              >
                <div className="flex aspect-[4/3] items-center justify-center bg-[linear-gradient(135deg,#f0d6aa,#ddb87a,#c79653)]">
                  <span className="text-sm uppercase tracking-[0.2em] text-[#5c4427]">
                    Cover Coming Soon
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold tracking-tight">{b.t}</h3>
                  <p className="mt-2 text-sm leading-7 text-[#685a4d]">{b.s}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#f6f0e6] py-20">
        <div className="mx-auto max-w-5xl px-6">
          <div className="rounded-[34px] bg-[#1b1512] px-8 py-12 text-white md:px-12 md:py-14">
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#d4b285]">
              Support the Vision
            </p>
            <h2 className="mt-3 text-3xl font-semibold tracking-tight md:text-4xl">
              Help place these books into more homes and classrooms.
            </h2>
            <p className="mt-5 max-w-2xl text-[16px] leading-8 text-white/74">
              Support helps expand the series, increase accessibility, and place
              culturally-rooted children’s books into the hands of more families.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="https://givebutter.com/fDk01G"
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-full bg-[#f1ede6] px-6 py-3.5 text-sm font-medium text-[#191512]"
              >
                Gift a Classroom
              </a>
              <a
                href="mailto:community@oneunityrising.org"
                className="rounded-full border border-white/15 bg-white/8 px-6 py-3.5 text-sm font-medium text-white"
              >
                Contact
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="border-t border-black/6 bg-[#f6f0e6]">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-10 text-sm text-[#6a5a4c] sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} One Unity Rising • Books</p>
          <div className="flex gap-6">
            <a href="/#involved" className="transition hover:text-black">
              Get Involved
            </a>
            <a
              href="mailto:community@oneunityrising.org"
              className="transition hover:text-black"
            >
              Contact
            </a>
          </div>
        </div>
      </footer>
    </main>
  );
}